<div class="divContent">
    <span class="texto">{{data.message}}</span>
    <button class="button" mat-button (click)="snackBarRef.dismiss()">
        <mat-icon>clear</mat-icon>
    </button>
</div>